import { API_ENDPOINTS } from "./Constants";
import { apiFetch } from "./apiHelper";

export async function getUserMessages() {
    try {
        const response = await apiFetch(API_ENDPOINTS.MESSAGES, {
            method: "GET",
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error("Greška prilikom dohvaćanja poruka.");
        }

        return await response.json();
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function markAsRead(id) {
    try {
        const response = await apiFetch(API_ENDPOINTS.MESSAGES_SET_READ(id), {
            method: "PUT",
            credentials: "include",
        });

        if (!response.ok) {
            const errMsg = await response.text();
            throw new Error(errMsg || "Greška prilikom označavanja poruke.");
        }

        return await response.text();
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export async function hasUnreadMessages() {
    try {
        const response = await apiFetch(API_ENDPOINTS.MESSAGES_UNREAD, {
            method: "GET",
            credentials: "include",
        });

        if (!response.ok) {
            return false;
        }

        const data = await response.json();
        return !!data;
    } catch (error) {
        console.error("Greška pri provjeri nepročitanih poruka:", error);
        return false;
    }
}

